<div class="container min-vh-100">
  <div class="row min-vh-100 justify-content-center align-items-center">

    <div class="vid-card vid-card-padding vid-card-enrollment">

      <ng-container *ngIf="!initiated && !selfInitEnrollment">
        <p class="section-title">{{ 'ENROLLMENT.AUTHENTICATED_ENROLLMENT_TITLE' | translate }}</p>
        <p class="mt-1 vid-list-item-help">{{ 'ENROLLMENT.AUTHENTICATED_ENROLLMENT_MESSAGE' | translate}}</p>
        <button id="enrollBtn" (click)="init()" type="button"
                class="float-end vid-btn vid-btn-sm mb-2">{{ 'ENROLLMENT.AUTHENTICATED_ENROLLMENT_ENROLL_BTN' | translate }}</button>
      </ng-container>

      <ng-container *ngIf="initiated">

        <form *ngIf="step == Step.Main" class="col-12" (ngSubmit)="onSubmitDynamicForm()" [formGroup]="dynamicForm">

          <div class="mb-4">
            <div class="section-title">{{schema.title}}</div>
            <div *ngIf="schema.pageDescription" class="mt-1 vid-list-item-help">{{schema.pageDescription}}</div>
          </div>

          <div *ngFor="let field of schema.parameters" class="mb-3">
            <label [for]="field.name" class="form-label section-description">{{field.title}}</label>
            <input *ngIf="field.controlType == 'string'" [formControlName]="field.name" type="text"
                   [id]="field.name" class="form-control vid-input mt-1 mb-0">
            <div>
              <span *ngIf="field.patternMessage" class="vid-list-item-help">{{field.patternMessage}}</span>
            </div>
            <input *ngIf="field.controlType == 'number'" [formControlName]="field.name" type="text"
                   pattern="[0-9]*" [id]="field.name" class="form-control vid-input mt-1 mb-0">
            <div *ngIf="field.controlType == 'password'" class="d-inline-flex w-100 position-relative">
              <img (click)="changeInputType(field.name)"  [src]="getInputType(field.name) === 'text' ? 'assets/icons/hide.png' : 'assets/icons/view.png'"
                   class="img-show-password" />
              <input *ngIf="field.controlType == 'password'" [formControlName]="field.name" [type]="getInputType(field.name)"
                     [id]="field.name" class="form-control vid-input mt-1 mb-0">
            </div>
            <select *ngIf="field.controlType == 'enum' && field.value.length != 0"
                    [formControlName]="field.name" [id]="field.name" class="form-control form-select form-select-sm vid-input mt-1 mb-0">
              <option *ngFor="let opt of field.value; let i = index" [value]="opt">
                {{'ENROLLMENT.OPTIONS_' + opt | translate}}
              </option>
            </select>
          </div>

          <div class="mb-3 text-end mt-2">
            <button id="nextBtn2" type="submit" [disabled]="!dynamicForm.valid"
                    class="vid-btn vid-btn-blue vid-btn-sm ms-1">{{nxtBtnTxt | translate }}</button>
          </div>
        </form>

        <div *ngIf="step == Step.ChooseAuthMethod" class="row d-flex justify-content-center">
          <div *ngIf="registrationQR" class="row col-sm-12 d-flex justify-content-center">
                        <span class="vid-list-item-help text-center">{{ 'ENROLLMENT.REGISTER_NEW' | translate }} <a
                          routerLink="/authenticators">{{ 'ENROLLMENT.HERE' | translate }}</a>.</span>
            <qrcode [qrdata]="registrationQR" cssClass="qr-container" errorCorrectionLevel="L"></qrcode>
            <span class="vid-list-item-help text-center"></span>
          </div>
          <span *ngIf="authenticationMethods && authenticationMethods.length > 0"
                class="mt-2 vid-list-item-help text-center">{{ 'ENROLLMENT.MORE_AUTH' | translate }}</span>
          <span *ngIf="!authenticationMethods || authenticationMethods.length == 0"
                class="mt-2 vid-list-item-help text-center">{{ 'ENROLLMENT.NO_AUTH' | translate }}</span>
          <div class="row col-sm-12 mt-2 d-flex justify-content-center">
            <ng-container *ngFor="let authMethod of authenticationMethods">
              <div *ngIf="authMethod.name === 'SMS'" class="vid-authentication-method" (click)="selectAuthMethod(authMethod.name)">
                <img src='assets/nucleo/mobile-chat.png' class="img-responsive" />
                <span text-center>{{ 'AUTHENTICATORS.SMS' | translate }} </span>
              </div>
              <div *ngIf="authMethod.name === 'FIDO'" class="vid-authentication-method" (click)="selectAuthMethod(authMethod.name)">
                <img src='assets/nucleo/fido_logo_transparent.png' class="img-responsive" />
                <span text-center>{{ 'AUTHENTICATORS.FIDO' | translate }}</span>
              </div>
              <div *ngIf="authMethod.name === 'DESKTOP_FACE'" class="vid-authentication-method" (click)="selectAuthMethod(authMethod.name)">
                <img src='assets/nucleo/face-recognition.png' class="img-responsive" />
                <span text-center>{{ 'AUTHENTICATORS.VFACE' | translate }}</span>
              </div>
              <div *ngIf="authMethod.name === 'PIN' && !authMethod.enrolled" class="vid-authentication-method" (click)="selectAuthMethod(authMethod.name)">
                <img src='assets/nucleo/password.png' class="img-responsive" />
                <span text-center>{{ 'AUTHENTICATORS.PIN' | translate }}</span>
              </div>
              <div *ngIf="authMethod.name === 'YUBICO_OTP'" class="vid-authentication-method" (click)="selectAuthMethod(authMethod.name)">
                <img src='assets/nucleo/hardware-auth-device.png' class="img-responsive" />
                <span text-center>{{ 'AUTHENTICATORS.YUBICO_OTP' | translate }}</span>
              </div>
              <div *ngIf="authMethod.name === 'HW_OTP'" class="vid-authentication-method" (click)="selectAuthMethod(authMethod.name)">
                <img src='assets/nucleo/hw_otp.png' class="img-responsive" />
                <span text-center>{{ 'AUTHENTICATORS.HW_OTP' | translate }}</span>
              </div>
              <div *ngIf="authMethod.name === 'SW_OTP'" class="vid-authentication-method" (click)="selectAuthMethod(authMethod.name)">
                <img src='assets/nucleo/sw_otp.png' class="img-responsive" />
                <span text-center>{{ 'AUTHENTICATORS.SW_OTP' | translate }}</span>
              </div>
              <div *ngIf="authMethod.name === 'DESKTOP_FINGERPRINT'" class="vid-authentication-method" (click)="selectAuthMethod(authMethod.name)">
                <img src='assets/fingerprint_small.png' class="img-responsive" />
                <span text-center>{{ 'AUTHENTICATORS.FINGERPRINT' | translate }}</span>
              </div>
            </ng-container>
          </div>
        </div>

        <form *ngIf="step == Step.Advance || step == Step.EnrollAuthMethod"  class="col-12" (ngSubmit)="onSubmitDynamicForm()" [formGroup]="dynamicForm">

          <div class="mb-4">
            <div class="section-title">{{schema.title}}</div>
            <div *ngIf="schema.pageDescription" class="mt-1 vid-list-item-help">{{schema.pageDescription}}</div>
          </div>
          <div *ngIf="authMethod === 'SW_OTP'&& step === Step.EnrollAuthMethod" class="vid-container-qr">
            <qrcode [qrdata]="swOtpQr" errorCorrectionLevel="L"></qrcode>
            <i class="vid-secret-text"><b>{{'ENROLLMENT.SW_QR_SECRET' | translate}} </b>{{swOtpSecretKey}}</i>
          </div>

          <div *ngFor="let field of schema.parameters" class="mb-3">
            <ng-container *ngIf="!field.hidden">
              <label [for]="field.name" class="form-label section-description">{{field.title}}</label>
              <input *ngIf="field.controlType == 'string'" [formControlName]="field.name" type="text"
                     [id]="field.name" class="form-control vid-input mt-1 mb-0">
              <input *ngIf="field.controlType == 'number'" [formControlName]="field.name" type="text"
                     pattern="[0-9]*" [id]="field.name" class="form-control vid-input mt-1 mb-0">
              <input *ngIf="field.controlType == 'password'" [formControlName]="field.name" type="password"
                     [id]="field.name" class="form-control vid-input mt-1 mb-0">
              <select *ngIf="field.controlType == 'enum' && field.value.length != 0"
                      [formControlName]="field.name" [id]="field.name" class="form-control form-select form-select-sm vid-input mt-1 mb-0">
                <option *ngFor="let opt of field.value; let i = index" [value]="opt">
                  {{'ENROLLMENT.OPTIONS_' + opt | translate}}
                </option>
              </select>
              <div>
                <span *ngIf="field.patternMessage" class="vid-list-item-help">{{field.patternMessage}}</span>
              </div>

            </ng-container>
          </div>

          <div *ngIf="step == Step.Advance || step == Step.EnrollAuthMethod" class="mb-3 text-end">
            <button id="restartBtn" *ngIf="restartBtnAvailable && !restartBtnHiddenByPreviousStep"
                    [disabled]="restartBtnDisabled" (click)="onRestartStep()" type="button"
                    class="vid-btn vid-btn-green vid-btn-sm ms-1">{{restartBtnTxt | translate }}</button>
            <button id="backBtn2" (click)="onReset()" type="button"
                    class="vid-btn vid-btn-red vid-btn-sm ms-1">{{ 'ENROLLMENT.BACK' | translate }}</button>
            <button id="nextBtn2" type="submit" [disabled]="!dynamicForm.valid"
                    class="vid-btn vid-btn-blue vid-btn-sm ms-1">{{nxtBtnTxt | translate }}</button>
          </div>
        </form>

        <div [hidden]="step != Step.EnrollVface" class="row">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-12">
                <div class="mb-4">
                  <div class="section-title">{{ 'ENROLLMENT.VFACE' | translate }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 text-end">
                <!-- <button id="faceEnrollBtn" id="enroll" type="button"
                    class="vid-btn vid-btn-red vid-btn-sm ms-1">{{ 'ENROLLMENT.START_VFACE' | translate
                    }}</button> -->
              </div>
            </div>
          </div>
        </div>

        <form *ngIf="step === Step.EnrollDesktopTouchId" class="col-12" [formGroup]="fingerprintEnrollmentForm">
          <div class="row">
            <div class="col-sm-12">
              <div class="mb-4">
                <div class="section-title">{{ 'ENROLLMENT.FINGERPRINT' | translate }}</div>
                <div class="section-description" >{{ fingerScannerMessage }}</div>
              </div>
            </div>
          </div>
          <div class="mb-3 vid-column-equal d-flex justify-content-between">
            <button (click)="scanFingerprint()" id="scanFingerprint" type="button" [disabled]="!selectedScanner"
                    class="vid-btn vid-btn-blue vid-btn-sm ">Scan Fingerprint</button>
            <button (click)="registerFingerprint()" id="registerFingerprint" type="button" [disabled]="!fingerprintImage"
                    class="vid-btn vid-btn-blue vid-btn-sm ">Register Fingerprint</button>
          </div>
          <img [src]="fingerprintImage" *ngIf="fingerprintImage && biometricTemplate == 'Bitmap'" />
        </form>


        <form *ngIf="step === Step.EnrollFidoIdp" class="col-12"
              (ngSubmit)="onSubmitFidoIdpForm()" [formGroup]="fidoIdpForm">

          <div class="mb-4">
            <div class="section-title">{{ 'ENROLLMENT.SELECT_IDP' | translate }}</div>
          </div>

          <div class="mb-3">
            <label [for]="idp" class="form-label section-description">{{ 'ENROLLMENT.IDP' | translate }}</label>
            <select formControlName="idp" id="idp" class="form-control form-select form-select-sm vid-input mt-1 mb-0">
              <option *ngFor="let opt of fidoRPs; let i = index" [ngValue]="opt">
                {{opt.name}}, {{opt.url}}
              </option>
            </select>
          </div>
          <div class="mb-3 text-end mt-2">
            <button id="saveFidoBtn" type="submit" [disabled]="!fidoIdpForm.valid"
                    class="vid-btn vid-btn-blue vid-btn-sm">{{ 'ENROLLMENT.SAVE' | translate }}</button>
          </div>
        </form>


        <div *ngIf="step === Step.EnrollFido">

          <div class="mb-4">
            <div class="section-title" id="fido-title">{{ 'ENROLLMENT.FIDO_START_REGISTER' | translate }}</div>
            <div *ngIf="!fidoEnrollmentExternalScriptDone" class="mt-1 vid-list-item-help">{{
                'ENROLLMENT.FIDO_START_REGISTER_DESCRIPTION' | translate }}</div>
          </div>

          <form *ngIf="fidoEnrollmentExternalScriptDone" class="col-12" (ngSubmit)="onSubmitFidoEnrollmentForm()"
                [formGroup]="fidoEnrollmentForm">
            <div *ngIf="fidoKeys?.length > 0" class="mb-3">
              <div class="form-check">
                <input id="existing" type="radio" class="form-check-input" value="existing"
                       name="registrationOption" formControlName="registrationOption">
                <label class="form-label custom-control-label" for="existing">{{ 'ENROLLMENT.FIDO_ALREADY_EXIST' |
                  translate }}</label>
              </div>
              <div class="form-check">
                <input id="new" type="radio" class="form-check-input" value="new"
                       name="registrationOption" formControlName="registrationOption">
                <label class="form-label custom-control-label" for="new">{{ 'ENROLLMENT.FIDO_NEW_DEVICE' | translate
                  }}</label>
              </div>
            </div>

            <div *ngIf="this.fidoEnrollmentForm.get('registrationOption').value == 'existing'"
                 class="mb-3">
              <label for="selectedExistingKey" class="form-label section-description">{{
                  'ENROLLMENT.FIDO_ALREADY_EXIST_DESCRIPTION' | translate }}</label>
              <select formControlName="selectedExistingKey" id="selectedExistingKey"
                      class="form-control form-select form-select-sm vid-input mt-1 mb-0"
                      (change)="onDeviceNameSelection($event)"
                      [(ngModel)]="selectedDeviceNm">
                <option *ngFor="let opt of fidoKeys; let i = index" [ngValue]="opt">
                  {{opt}}
                </option>
              </select>
              <label for="selectedExistingKey" class="form-label section-description">{{
                  'ENROLLMENT.FIDO_EDIT_KEY_DESCRIPTION' | translate }}</label>
              <input formControlName="selectedName" id="selectedName" class="form-control vid-input mt-1 mb-0"
                     type="text" value="{{selectedDeviceNm}}"/>
            </div>
            <div *ngIf="this.fidoEnrollmentForm.get('registrationOption').value == 'new'" class="mb-3">
              <label for="customName" class="form-label section-description">{{ 'ENROLLMENT.FIDO_NEW_DEVICE_DESCRIPTION'| translate }}</label>
              <input formControlName="customName" type="text" id="customName"
                     class="form-control vid-input mt-1 mb-0">
            </div>
            <div class="mb-3 text-end mt-2">
              <button id="saveFidoEnrollmentBtn" type="submit" [disabled]="!fidoEnrollmentForm.valid"
                      class="vid-btn vid-btn-blue vid-btn-sm">{{ 'ENROLLMENT.FINISH' | translate }}</button>
            </div>
          </form>
          <!-- additional DOM elements used by identifiers by FIDO external js script -->
          <div class="mb-3 text-end mt-2 d-none">
            <input hidden="true" id="registerSessionFinish" name="j_registerSessionFinish" type="text">
            <input hidden="true" id="newDeviceName" name="newDeviceName" type="text">
            <button (click)="onUpdateFIDODetails()" id="updateFIDODetails" type="button"
                    class="vid-btn vid-btn-blue vid-btn-sm">Not to be shown</button>
            <button (click)="onCancelFIDOEnrollment()" id="cancelFIDOEnrollment" type="button"
                    class="vid-btn vid-btn-blue vid-btn-sm">Not to be shown</button>
          </div>
        </div>

        <div *ngIf="step === Step.Finished" class="row">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-12">
                <div class="mb-4">
                  <div class="section-title" *ngIf="authMethod !== 'YUBICO_OTP'
                                    && authMethod !== 'SW_OTP'
                                    && authMethod !== 'HW_OTP'
                                    && authMethod !== 'LDAP_PASSWORD'">{{authMethod}} {{ 'ENROLLMENT.FINISH_ENROLL' | translate }}</div>
                  <div class="section-title" *ngIf="authMethod === 'YUBICO_OTP'">Yubico OTP device {{ 'ENROLLMENT.FINISH_ENROLL'
                    | translate }}</div>
                  <div class="section-title" *ngIf="authMethod === 'SW_OTP'">OTP Application {{ 'ENROLLMENT.FINISH_ENROLL' | translate }}</div>
                  <div class="section-title" *ngIf="authMethod === 'HW_OTP'">Hardware OTP Token {{ 'ENROLLMENT.FINISH_ENROLL'| translate }}</div>
                  <div class="section-title" *ngIf="authMethod === 'LDAP_PASSWORD'">{{ 'ENROLLMENT.FINISH_LDAP_PASS_RESET' | translate }}</div>
                </div>
              </div>
            </div>
            <div class="mb-3 text-end mt-2">
              <button *ngIf="authenticationMethods" (click)="finish(false)" type="button" class="vid-btn vid-btn-green vid-btn-sm">{{ 'ENROLLMENT.CONTINUE' | translate }}</button>
              <button (click)="finish(true)" type="button" class="vid-btn vid-btn-red vid-btn-sm ms-1">{{ 'ENROLLMENT.FINISH' | translate }}</button>
            </div>
          </div>

        </div>

        <div *ngIf="step === Step.Timeout || step === Step.Failed" class="row">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-12">
                <div class="mb-4">
                  <div class="section-title">{{ (step === Step.Timeout ? 'ERROR.ENROLL_TIMEOUT' : 'ERROR.ENROLL_FAILED') | translate }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 text-end">
                <button id="resetBtn" (click)="onReset()" type="button"
                        class="vid-btn vid-btn-red vid-btn-sm">{{ 'ENROLLMENT.RETRY' | translate }}</button>
              </div>
            </div>
          </div>

        </div>

      </ng-container>
      <progressbar *ngIf="isLoading" style="margin-top: 8px; height: 10px;" [value]="100" type="info">
      </progressbar>
    </div>
  </div>
</div>
